import { getMenuListEU, isPathEk } from '@/utils/routes';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useStore } from '@/hooks/useStore';
import { RoleUserType } from '@/types/enums';

interface MenuProps {
    isOpen?: boolean,
    useSheetClose?: boolean,
    isMenuSheet?: boolean
}

export default function Menu({ isOpen, useSheetClose, isMenuSheet = false }: MenuProps) {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        authStore: { profileGas, profileEk }
    } = useStore();

    // function
    const getRoleCodeUser = (isEk: boolean): RoleUserType | undefined => {
        if (isEk) {
            if (!profileEk?.roleId) {
                return undefined;
            }
            return profileEk?.roleId as RoleUserType;
        } else {
            if (!profileGas?.roleId) {
                return undefined;
            }
            return profileGas?.roleId as RoleUserType;
        }
    };

    const menuList = getMenuListEU(pathname, getRoleCodeUser(isEk), t);

    return (
        <ul className=''>
            {
                menuList.map((menu, index) => {
                    const { label, decoration, href } = menu;

                    return (
                        <li key={index} className='leading-[1] border-b-2 border-[#262423]'>
                            <Link to={href} className='flex py-[min(18px,3vw)] px-2 gap-[10px] items-end'>
                                <span className='font-semibold text-[min(20px,calc(100vw/15))]'>{label}</span>
                                <span className='text-primaryWeb text-[min(12px,3.2vw)]'>{decoration}</span>
                            </Link>
                        </li>
                    );
                })
            }
        </ul>
    );
}
